import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment CharterSchoolFragment on Organization {
    uid
    name
    state
    logoUrl
    urlName
  }
`;
